import { useMemo } from 'react'
import Dropdown from 'shared/Inputs/Dropdown'
import { IOption } from 'types/global'

interface IProps {
  value: number
  name: string
  onChange: (value: number, name: string) => void
}

const RrojectEducationYearDropdown = (props: IProps) => {
  const onChange = (option: { title: string; value: number }, name: string) => {
    props.onChange(option.value, name)
  }

  const selected = useMemo(() => {
    return options.find((o) => o.value === props.value) || null
  }, [props.value, options])
  return (
    <Dropdown
      onSelect={onChange}
      name={props.name}
      options={options}
      selectedOption={selected}
      title='Год обучения'
      allowEmpty={false}
      getOptionLabel={(o) => o?.title as string}
      getOptionKey={(o) => o?.value}
    />
  )
}

const options: Array<IOption<number>> = [
  { value: 1, title: '1' },
  { value: 2, title: '2' },
  { value: 3, title: '3' },
  { value: 4, title: '4' },
  { value: 5, title: '5' },
]

export default RrojectEducationYearDropdown
